(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  $(document).ready(function(){
     document.body.addEventListener('click', function(e) {
    if (document.body.classList.contains('content-open')) {
        e.preventDefault();
       
        const target = e.target;
       
        // Check if target has class 'show'
        if (target.classList.contains('show')) {
          const firstChild = target.firstElementChild;
       
          // Check if first child exists and has class 'overlay'
          if (firstChild && firstChild.classList.contains('overlay')) {
            target.classList.remove('show');            
          } 
        }
    }
      });
    $('.link-click a').on('click',function(e){
      e.preventDefault();
      var target = $(this).parents('.announcement__text').data('target');
      $('#'+target).addClass('show')
      $('body').css('overflow','hidden')
      $('body').addClass('content-open')
    })
    $('.close-btn').on('click',function(e){
      $('.vooray-pop-content').removeClass('show')
      $('body').css('overflow','scroll')
      $('body').removeClass('content-open')
    })
  })

  } catch(e) { console.error(e); }
})();
})();
